// extracted by mini-css-extract-plugin
module.exports = {"commentBar":"comment-bar_commentBar_352","timeText":"comment-bar_timeText_1sD"};